module.exports = __webpack_public_path__ + "static/media/author_img_2.399442be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/author_img_2.jpg
// module id = 778
// module chunks = 0